import React from 'react';
import styled from 'styled-components';
import {Button, ButtonProps} from '@material-ui/core';

const StyledButtonBase = styled(Button)`
  font-family: 'Trade Gothic Bold Condensed';
  min-width: 190px;
  border-radius: 4px;
  color: ${props => props.theme.text};
  border: 1px solid ${props => props.theme.white};
  background-color: transparent;
  text-decoration: none;
  text-transform: capitalize;
  display: block;
  padding-top: 4px;
  padding-right: 10px;
  padding-bottom: 4px;
  padding-left: 10px;
`;

interface ModalButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export default function ModalButton({children, ...props}: ModalButtonProps) {
  return <StyledButtonBase {...props}>{children}</StyledButtonBase>;
}
